import { useGetInfoUserQuery, useGetProfileQuery } from 'redux/Api/profileApi/ProfileApi';

const COUNTER_ID = Number(process.env.REACT_APP_COUNTER_ID);

const isWorksupportRole = () =>
  (localStorage.getItem('role') || '').toLowerCase() === 'worksupport';

const useYandexMetrica = () => {
  const isAuth = !!localStorage.getItem('token');

  const { data: userData } = useGetInfoUserQuery(undefined, {
    skip: !isAuth || isWorksupportRole(),
  });
  const { data } = useGetProfileQuery(undefined, {
    skip: !isAuth || isWorksupportRole(),
  });

  const CustomerId_UserId = data?.id && userData?.id ? `${data.id}_${userData.id}` : '';

  const sendGoal = (goalName: string) => {
    if (isNaN(COUNTER_ID) || COUNTER_ID === 0) return;
    if (isWorksupportRole()) return;
    if (typeof window !== 'undefined' && window.ym) {
      if (CustomerId_UserId) {
        window.ym(COUNTER_ID, 'reachGoal', goalName, { CustomerId_UserId });
      } else {
        window.ym(COUNTER_ID, 'reachGoal', goalName);
      }
    }
  };

  return { sendGoal };
};

export default useYandexMetrica;
